import { getSeconds } from './time';
import { getRandomNumber } from './util';
import { isFromAd } from './document';

export const setCookie = (name, value, minutes, counterId) => {
  const cookieOptions = [
    `${counterId ? prepareName(name, counterId) : name}=${encodeURIComponent(
      value
    )}`,
  ];
  const domain = window.location.hostname;

  if (minutes) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + 60000 * minutes);
    cookieOptions.push(`expires=${expirationDate.toUTCString()}`);
  }

  if (domain) {
    cookieOptions.push(`domain=${domain}`);
  }

  cookieOptions.push('path=/');

  try {
    document.cookie = cookieOptions.join(';');
  } catch (error) {
    // do nothing
  }
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const removeCookie = (name, counterId) => {
  setCookie(name, '', -1, counterId);
};

const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, encodeURIComponent(value));
  } catch (e) {
    // do nothing
  }
};

export const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const generateId = () => {
  return `${getSeconds()}${getRandomNumber()}`;
};

export const prepareName = (name, counterId) => {
  return name === 'xsollauid'
    ? name
    : `_mm_${name}${counterId ? `_${counterId}` : ''}`;
};

export const getGoogleAnalyticsClientId = () => {
  const raw = getCookie('_ga');
  if (raw) {
    const match = raw.match(/(\d+\.\d+)$/);
    return match ? match[1] : null;
  }
  return null;
};

export const getVid = (visitId, counterId) => {
  if (visitId !== null) {
    return visitId;
  }

  const generateNew = isFromAd();
  let vid = generateNew ? null : getCookie(prepareName('vid', counterId));

  if (!vid) {
    vid = generateId();
  }

  setCookie('vid', vid, 30, counterId);

  return vid;
};

export const getUid = (counterId) => {
  let uid = getCookie(prepareName('uid', counterId)) || null;
  const uidLS = getLocalStorage(prepareName('uid', counterId)) || null;

  if (!uid && !uidLS) {
    uid = generateId();
    setCookie('uid', uid, 1036800, counterId);
    setLocalStorage(prepareName('uid', counterId), uid);
  } else if (!uid && uidLS) {
    uid = uidLS;
    setCookie('uid', uid, 1036800, counterId);
  } else if (uid && !uidLS) {
    setLocalStorage(prepareName('uid', counterId), uid);
  }

  return uid;
};

export const getXsollauid = (id, counterId) => {
  const xid = getCookie(prepareName('xsollauid', counterId)) || null;
  const xidLS = getLocalStorage(prepareName('xsollauid', counterId)) || null;

  if (!id) {
    if (xid && !xidLS) {
      setLocalStorage(prepareName('xsollauid', counterId), xid);
    } else if (!xid && xidLS) {
      setCookie('xsollauid', xidLS, 5184000, counterId);
    }
    return xid || xidLS;
  }

  setCookie('xsollauid', id, 5184000, counterId);
  setLocalStorage(prepareName('xsollauid', counterId), id);

  return id;
};
